import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Remonte en haut de page à chaque changement de route.
 *
 * React Router conserve la position de scroll par défaut : sans ce composant,
 * cliquer un CTA en bas d'une page fait atterrir en bas de la page suivante.
 *
 * Exception : si l'URL contient une ancre (ex. /devenir-createur#candidature,
 * /vision#fondateurs), on ne touche à rien — la page cible gère elle-même son
 * scroll vers l'ancre (voir BecomeVendor.jsx / IAPage.jsx).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // navigation ancrée → laissée à la page cible
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
